// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5d438657","455":"02bc0593","977":"4b5710cc"}[chunkId] + ".chunk.js";
};